.modalContent {
  height: 30rem;
  overflow: auto;
  padding: 0 2px;
}

.textAreaContainer input {
  margin-bottom: 1em;
}

.textAreaContainer label {
  font-size: 1rem;
  line-height: 2rem;
  color: var(--black);
  font-weight: unset;
}

.requiredText {
  font-size: 0.9em;
  color: var(--darkSilver);
  margin-left: 0.2em;
  margin-bottom: 0.2em;
  display: inline-flex;
}
